export const GET_MEETINGS_REQUEST = 'GET_MEETINGS_REQUEST';
export const GET_MEETINGS_SUCCESS = 'GET_MEETINGS_SUCCESS';
export const GET_MEETINGS_FAILURE = 'GET_MEETINGS_FAILURE';

export const CREATE_MEETING_REQUEST = 'CREATE_MEETING_REQUEST';
export const CREATE_MEETING_SUCCESS = 'CREATE_MEETING_SUCCESS';
export const CREATE_MEETING_FAILURE = 'CREATE_MEETING_FAILURE';

export const UPDATE_MEETING_REQUEST = 'UPDATE_MEETING_REQUEST';
export const UPDATE_MEETING_SUCCESS = 'UPDATE_MEETING_SUCCESS';
export const UPDATE_MEETING_FAILURE = 'UPDATE_MEETING_FAILURE';

export const DELETE_MEETING_REQUEST = 'DELETE_MEETING_REQUEST';
export const DELETE_MEETING_SUCCESS = 'DELETE_MEETING_SUCCESS';
export const DELETE_MEETING_FAILURE = 'DELETE_MEETING_FAILURE';

export const GET_MEETINGS_BY_PROJECT_REQUEST = 'GET_MEETINGS_BY_PROJECT_REQUEST';
export const GET_MEETINGS_BY_PROJECT_SUCCESS = 'GET_MEETINGS_BY_PROJECT_SUCCESS';
export const GET_MEETINGS_BY_PROJECT_FAILURE = 'GET_MEETINGS_BY_PROJECT_FAILURE';